
import { localDateToUSFormat } from "../../general_components/content_management/item_page/driver_page_components/payoutAdjustmentsSection";
import { NestedValueExtractor } from "../../general_components/content_management/list_view/listView";
import { priceOnFinish } from "../../supplementary_components/priceInputDelegate";
import {API_ROOT } from '../../supplementary_components/requests';
import {  RATE_CONF_FETCH_CONF } from "./loadAddConf"; //LOAD_ADD_CONF,
import { LOAD_PAGE_OBJECT } from "./loadPageConf";
// import { FaRegFileLines } from "react-icons/fa6";
// import { addPopup } from "../../supplementary_components/store";


const ROOT_PATH = '/loads/'

export const loadStatusFormatter = (val) => {
    switch (val) {
        case "NotDispatched":
            return "Not Dispatched";
        case "PickedUp":
            return "Picked Up";
        case "InProgress":
            return "In Progress";
        case "Picked Up":
            return "PickedUp";
        case "Not Dispatched":
            return "NotDispatched";
        case "In Progress":
            return "InProgress";
        case "LateForDelivery":
            return "Late For Delivery";
        case "ReadyForInvoice":
            return "Ready For Invoice";
        case "Ready For Invoice":
            return "ReadyForInvoice";
        default:
            return val;
    }
}
//     Unassigned,
//     Cancelled,
//     NotDispatched,
//     Dispatched,
//     InProgress,
//     Completed,
//     Invoiced,
//     Paid,
//     Terminated
export const loadStatusColorGenerator = (val) =>{
    switch (val) {
        case "Unassigned":
            return "var(--lightAlert)"; //light alert
        case "Cancelled":
            return "var(--lightAlert)";
        case "Late":
            return "var(--lightAlert)";
        case "LateForDelivery":
            return "var(--lightAlert)";
        case "Terminated":
            return "var(--lightAlert)";
        case "NotDispatched":
            return "var(--inProgressYellow)"; // inProgressYellow
        case "Onsite":
            return "var(--inProgressYellow)"; // inProgressYellow
        case "Dispatched":
            return "var(--inProgressBlue)"; // inProgressBlue 
        case "InProgress":
            return "var(--inProgressGreen)"; // inProgressGreen
        case "Completed":
            return "var(--successGreen)"; // successGreen
        case "ReadyForInvoice":
            return "var(--successGreen)"; // successGreen
        case "Invoiced":
            return "var(--preFinishGreen)"; //preFinishGreen
        default:
            return "var(--successGreen)";
    }
}

export const LOAD_LISTING_CONF = {    
    getRequestLink: API_ROOT+"loads",
    // columnProportions: "6.5% 13.3% 10.66% 8.37% 18.5% 11.86% 13.37% 1fr",
    columnProportions: "1fr 0.7fr 17% 0.8fr 1fr 1fr 0.8fr 0.8fr 0.7fr 1fr",
    dataTitle: "Load",
    dataTitlePlural:"Loads",
    addButton:true,
    EZCloseAllowed:false,
    addConf: RATE_CONF_FETCH_CONF,
    filteredResultsSummary: {
        label: "Total Rate",
        valueExtractor: (row) => Number(row.payout) || 0,
        formatter: (sum) => priceOnFinish(sum.toFixed(2)),
    },
    filtration:{
        multipleFiltrationAllowed: true,
        filtrationLinkRoot: "loads/filtration",
        searchByFieldNames:[
            {
                valueLocation: "loadNumber",
                categoryLbl: "By Load Number",
            },
            {
                valueLocation: "currentTruck.truckNumber",
                filtrationLbl: "truck:",
                searchKey: "byTruckNumber",
                hint: "Truck Number",
                
                // notInMultiFilterMode: true,
            },
            {
                valueLocation: "currentTrailer.trailerNumber",
                filtrationLbl: "trailer:",
                searchKey: "byTrailerNumber",
                hint: "Trailer Number",
                
            },
            {
                valueLocation: "broker.brokerageName",
                filtrationLbl: "broker:",
                searchKey: "byBrokerageName",
                hint: "Brokerage Name",
                
            },
            {
                valueLocation: ["startCityState", "endCityState"],
                filtrationLbl: "from-to:",
                searchKey: "byLocation",
                hint: "Locations (TX - CA)",
                splittingChar: ";"
            },
            {
                valueLocation: 'loadStatus',
                filtrationLbl: "status:",
                searchKey: "byStatus",
                hint: "Status",
                searchTermTransformer: (term)=>{return term.replaceAll(" ", "")},
                
                customSuggestions:[
                    "Unassigned",
                    "Not Dispatched",
                    "Dispatched",
                    "In Progress",
                    "Completed",
                    "Ready For Invoice",
                    "Invoiced",
                    "Paid",
                    "Terminated",
                    "Cancelled",
                ]
            },
            {
                valueLocation: "startDate",
                filtrationLbl: "start-date:",
                searchKey: "byStartDate",
                hint: "Start Date",
                extendedHint: "Start Date",
                customMaxWidth: "20rem",
                notInInlineFilterMode: true,
                inputFormat: "date",
                calendarPickType: 'range',
            },
            {
                valueLocation: "endDate",
                filtrationLbl: "end-date:",
                searchKey: "byEndDate",
                hint: "End Date",
                extendedHint:  "End Date",
                customMaxWidth: "20rem",
                notInInlineFilterMode: true,
                inputFormat: "date",
                calendarPickType: 'range',
            },
        ]
    },
    pageConf: new LOAD_PAGE_OBJECT(NestedValueExtractor, loadStatusFormatter, loadStatusColorGenerator),
    category: 'loads',
    columns :[
        {
            label: "Load",
            columnName: "loadNumber",
            clickable: true,
            identifierColumnName: "id",
            path: ROOT_PATH,
        },
        {
            label: "Truck Number",
            columnName: "truckNumber",
            valueGenerator: (data)=>{
                if(data['currentTruck'] === null){
                    return "-"
                }
                return data['currentTruck']['truckNumber'];
            },
            sortable: true,
        },
        {
            label: "Broker",
            columnName: "broker",
            valueGenerator: (data)=>{
                return NestedValueExtractor(data, [["broker", "brokerageName"]]);
            },
            sortable: true,
        },
        {
            label: "Rate",
            columnName: "payout",
            valueGenerator: (data)=>{
                return priceOnFinish(data["payout"], true);
                // return `${data["payout"]}`;
            },
            sortable: true,
            sortByRawValue: true,
        },
        {
            label: "Origin City",
            columnName: "startCityState",
            sortable: true,
        },
        {
            label: "End City",
            columnName: "endCityState",
            sortable: true,
        },
        {
            label: "Start Date",
            columnName: "startDate",
            valueGenerator: (data)=>{
                return localDateToUSFormat(data.startDate);
            },
            sortable: true,
            valuesAreDates: true,
        },
        {
            label: "End Date",
            columnName: "endDate",
            valueGenerator: (data)=>{
                return localDateToUSFormat(data.endDate) ;
            },
            sortable: true,
            valuesAreDates: true,
        },
        {
            label: "Missing Paperwork",
            // columnName: "files",
            valueGenerator:(data)=>{
                if(data.loadStatus === "Invoiced")return "-";
                const GoesThroughFactoring = NestedValueExtractor(data, [["broker", "factorInvoices"]]);
                const fileTypes = data["files"];
                let result = "All Set";
                if(!fileTypes.includes("Rate Con")){
                    result = "Rate Conf";
                }
                if(!fileTypes.includes("POD")){
                    result = result === "All Set" ? "POD" : result+"/POD";
                }
                
                
                return `${result} ${GoesThroughFactoring === '-' ? "(Not Factored)" : ""}`;
                // broker, factorInvoices
            },
            // valueInterpreter: (fileTypes)=>{
                
            //     return result;
            // },
            conditionalFormatting: (value)=>{
                return `& > * {color:${ value.includes("(Not Factored)") ?  "var(--light-gray)" : value.includes("Rate Con") || value.includes("POD") ? "var(--lightAlert)" : value !== "-" ?  "var(--successGreen)" : "" }; font-weight:bold;}`

            },
        },
        {
            label: "Status",
            columnName: "loadStatus",
            alignment: "right",
            conditionalFormatting: (value)=>{
                let color = loadStatusColorGenerator(value);
                return `& > * {color:${color}; font-weight:bold;}`

            },
            valueInterpreter: (value)=>{
                return loadStatusFormatter(value);
            },
            sortable: true,
        }
    ]
}